import { Link } from "react-router-dom";
import { FaTruck, FaChartLine } from "react-icons/fa";
import "./Products.css";

function Products() {
  return (
    <section className="products" id="products">
      <div className="products-section">
        <div className="products-header">
          <div className="products-icon">
            <svg width="50" height="50" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 2L4 5V11C4 16.55 7.84 21.74 12 23C16.16 21.74 20 16.55 20 11V5L12 2Z"
                fill="#8B5CF6"
              />
              <path
                d="M9.5 12L11.5 14L15.5 10"
                stroke="white"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <h2 className="products-title">Our Products</h2>
          <div className="products-underline"></div>
          <p className="products-subtitle">
            Innovative digital solutions that help businesses improve
            productivity, streamline operations and accelerate growth.
          </p>
        </div>
        <div className="products-cards">
          <Link to="/reward" className="product-card">
            <div className="card-background"></div>
            <div className="card-icon reward-icon">
              <FaChartLine />
            </div>
            <h3 className="card-title">
              REWARD
            </h3>
            <p className="card-description">
              Developed a watershed data analytics platform that processes AWS, NRM, and APSM data, performs automated calculations, and delivers interactive visualizations and reporting tools for improved decision-making.
            </p>
            <div className="card-hover-effect"></div>
          </Link>


          {/* <div className="product-card disabled-product">
            <div className="card-background"></div>

            <div className="card-icon reward-icon">
              <FaChartLine />
            </div>

            <h3 className="card-title">REWARD</h3>

            <p className="card-description">
              Developed a watershed data analytics platform that processes AWS, NRM, and APSM data, performs automated calculations, and delivers interactive visualizations and reporting tools for improved decision-making.
            </p>

            <div className="card-hover-effect"></div>
          </div> */}


          <Link to="/runmytransport" className="product-card">
            <div className="card-background"></div>

            <div className="card-icon transport-icon">
              <FaTruck />
            </div>

            <h3 className="card-title">
              RUN MY TRANSPORT
            </h3>

            <p className="card-description">
              A complete Transport Management System designed to streamline fleet
              operations, logistics, invoicing, payments, and reporting.
            </p>

            <div className="card-hover-effect"></div>
          </Link>
        </div>
      </div>
    </section>
  );
}
export default Products;